export enum ServiceType {
	Expense = 'expense',
	Income = 'income',
}
